/**
 * Privacy Policy page.
 */

export function Privacy() {
  return (
    <div className="pt-16">
      <div className="max-w-4xl mx-auto px-4 lg:px-8 py-24">
        <h1 className="text-4xl font-black text-white mb-8">Privacy Policy</h1>
        <div className="prose prose-invert prose-gray max-w-none">
          <p className="text-gray-400 text-lg mb-8">
            Last updated: January 2026
          </p>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p className="text-gray-400 mb-4">
              When you use bigflowdata services, we collect information necessary to provide
              our analytics services:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Account information (email, name)</li>
              <li>Shopify store data (orders, products) - only what you authorize</li>
              <li>Payment information (processed securely by Stripe)</li>
              <li>Usage data (how you use our services)</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Data</h2>
            <p className="text-gray-400 mb-4">
              We use your information to:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Provide and improve our analytics services</li>
              <li>Process payments and manage subscriptions</li>
              <li>Communicate with you about your account</li>
              <li>Ensure security and prevent fraud</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">3. Data Security</h2>
            <p className="text-gray-400">
              We implement industry-standard security measures to protect your data.
              Your Shopify data is encrypted in transit and at rest. We never share
              your data with third parties for marketing purposes.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">4. Your Rights</h2>
            <p className="text-gray-400 mb-4">
              Under GDPR and other privacy laws, you have the right to:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Delete your data</li>
              <li>Export your data</li>
              <li>Object to data processing</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">5. Contact Us</h2>
            <p className="text-gray-400">
              For privacy-related questions, contact us at:{' '}
              <a href="mailto:info@bigflowdata.com" className="text-brand-500 hover:text-brand-400">
                info@bigflowdata.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

